import './header-search-featured-card.scss';

import { faCaretUp } from '@fortawesome/free-solid-svg-icons';
import { Component, Vue, Watch } from 'vue-property-decorator';

import { ReactiveVue } from '@skinsoft/reactive-vue';
import { SearchFeatured, SearchFeaturedCard } from '../search-featured-card';

@Component({
    components: {
        sSearchFeaturedCard: SearchFeaturedCard,
    },
    props: ['searchFeatured', 'rounded', 'targetRouteName', 'displayBottom', 'abortPending'],
    template: require('./header-search-featured-card.html'),
})
export class HeaderSearchFeaturedCard extends ReactiveVue {

    public searchFeatured: SearchFeatured;
    public arrowIcon = faCaretUp;
    public displayBottom;
    public abortPending: boolean;

    private get materialsAndTechniques() {
        if (this.searchFeatured && this.searchFeatured.materialAndTechniques) {
            return this.searchFeatured.materialAndTechniques
        }
        return [];
    }

    private get measurements() {
        if (this.searchFeatured && this.searchFeatured.measurements) {
            return this.searchFeatured.measurements
        }
        return [];
    }

}
